import { CTA, styled, Text, TextTag, TokenTextColor } from "@volkswagen-onehub/components-core";
import { Edit } from "@volkswagen-onehub/icons-core";
import React, { useContext, useEffect, useState } from "react";
import Skeleton from 'react-loading-skeleton';
import { UserLocationContext } from "./UserLocationContext";
import { Emphasis } from "@volkswagen-onehub/components-core/dist/call-to-action";

interface UserLocationInterface {
  emphasis?: Emphasis;
  hideIcon?: boolean;
  inline?: boolean;
}

const StyledWrapper = styled.span<{inline: boolean}> `
  margin: 0;
  display: ${({inline}) => inline ? 'inline' : 'block'};
`;

const UserLocation = ({hideIcon = false, emphasis = 'none', inline = false} : UserLocationInterface) => {

  const userLocationContext = useContext(UserLocationContext);
  const { postalCode, promptUserForLocation } = userLocationContext;
  const [ skeleton, setSkeleton ] = useState(true);
  const [ postalCodeValue, setPostalCodeValue ] = useState("");

  const handleClick = () => {
    if (promptUserForLocation) {
      promptUserForLocation(postalCode || "");
    }
  };

  useEffect(() => {
    if (postalCode?.length) {
      setPostalCodeValue(postalCode);
      setSkeleton(false);
    }
  }, [postalCode])

  if (skeleton) {
    return (
      <Skeleton borderRadius="0" width="85px" height="20px" />
    );
  }

  return (
    <StyledWrapper inline={inline}>
      <CTA
        tag="button"
        emphasis={emphasis}
        onClick={handleClick}
        icon={!hideIcon ? <Edit variant="small"/> : undefined}
        iconPosition="end"
      >
        <Text tag={TextTag.span} color={TokenTextColor.inherit} bold>
          { postalCodeValue }
        </Text>
      </CTA>
    </StyledWrapper>
  );
};

export default UserLocation;
